import { render } from "./MealTable.vue?vue&type=template&id=b66fa772&scoped=true&ts=true"
import script from "./MealTable.vue?vue&type=script&lang=ts"
export * from "./MealTable.vue?vue&type=script&lang=ts"

import "./MealTable.vue?vue&type=style&index=0&id=b66fa772&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b66fa772"]])

export default __exports__